import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';

interface IApproachImageProps {
  image: string;
  alt: string;
  hasPictureOnRight: boolean;
}

export const ApproachImage: React.FC<IApproachImageProps> = ({
  image,
  alt,
  hasPictureOnRight,
}) => (
  <div className="approach-img">
    <div className="img">
      <ResponsiveImage src={image} alt={alt} layout="fill" objectFit="cover" />
    </div>
    <style jsx>{`
      .approach-img {
        flex: 0 1 40%;
        width: 100%;
        min-height: 250px;
        top: 0;
        bottom: 0;
      }

      .img {
        position: absolute;
        right: ${hasPictureOnRight ? '0' : 'unset'};
        left: ${hasPictureOnRight ? 'unset' : '0'};
        top: -65px;
        width: 55%;
        height: calc(100% + 130px);
        object-fit: cover;
        overflow: hidden;
      }

      @media (max-width: 800px) {
        .approach-img {
          position: relative;
        }

        .img {
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    `}</style>
  </div>
);
